var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObavijest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0768 12.5385V11.5385H21.3075V12.5385H18.0768ZM19.1615 19L16.5768 17.0615L17.2 16.2692L19.7845 18.2078L19.1615 19ZM17.123 7.73075L16.5 6.9385L19.0845 5L19.7075 5.79225L17.123 7.73075ZM5.65375 18V14.1922H4.61525C4.16792 14.1922 3.78683 14.0349 3.472 13.7202C3.15733 13.4054 3 13.0243 3 12.577V11.5C3 11.0527 3.15733 10.6716 3.472 10.3567C3.78683 10.0421 4.16792 9.88475 4.61525 9.88475H8.346L12.3075 7.5385V16.5385L8.346 14.1922H6.65375V18H5.65375ZM14.0767 14.927V9.15C14.4114 9.46033 14.681 9.86775 14.8855 10.3722C15.09 10.8767 15.1922 11.4322 15.1922 12.0385C15.1922 12.6448 15.09 13.2002 14.8855 13.7047C14.681 14.2092 14.4114 14.6167 14.0767 14.927Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObavijest);
export default __webpack_public_path__ + "static/media/obavijest.95e034b5ce406da5f1608eb7299ff381.svg";
export { ForwardRef as ReactComponent };